import {Component, Input, OnInit} from '@angular/core';
import {PedidosService} from "../../services/pedidos.service";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";

@Component({
  selector: 'app-razao-cancelamento-99food',
  templateUrl: './razao-cancelamento-99food.component.html',
  styleUrls: ['./razao-cancelamento-99food.component.scss']
})
export class RazaoCancelamento99foodComponent implements OnInit {
  @Input() pedido: any;
  @Input() modoGrupoLojas = false;
  razaoCancelamento: any;
  razoesCancelamento  = [];
  erroParaCancelar: string;
  constructor(protected pedidosService: PedidosService, protected grupolojasService: GrupolojasService) { }

  ngOnInit(): void {  }

  obtenhaRazoesCancamento(){
    if(!this.pedido || this.razoesCancelamento.length) return this.razoesCancelamento;

    if(!this.erroParaCancelar){
      this.getService().obtenhaRazoesCancelamento99Food(this.pedido).then((razoes: any) => {
        this.razoesCancelamento = razoes;
        if(!razoes.length)
          this.erroParaCancelar = 'Pedido não pode ser mais cancelado no 99food'

      }).catch((erro) => {
        this.erroParaCancelar = erro;
      })
    }
  }

  getService(): any {
    return this.modoGrupoLojas ? this.grupolojasService : this.pedidosService;
  }
}
